import { ReactNode } from "react";

import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { useVersion } from "../../hooks";
import { Logo } from "../logo/Logo";

type Props = {
  children: ReactNode;
};

export default function LoginFormWrapper({ children }: Props) {
  const { t } = useTranslation();
  const version = useVersion();

  return (
    <main>
      <div className="w-full h-screen flex flex-col md:items-center md:justify-center bg-gray-100 text-gray-700 overflow-hidden">
        <div className="flex flex-col md:flex-row bg-white border border-gray-200 w-full max-w-screen-md rounded-xl">
          <div className="order-2 md:order-1 w-full md:w-1/2 bg-white rounded-l-xl p-8 mt-4 min-h-[400px]">
            {children}
          </div>
          <div className="order-1 md:order-2 text-white bg-spf-blue p-10 d-md-down-none ml-auto w-full md:w-1/2 md:rounded-r-xl flex flex-row h-full place-items-center justify-center min-h-[400px]">
            <div className="text-center">
              <Logo size="8x" color="white" />
              <div className="tracking-widest">
                <h1 className="font-semibold text-4xl text-white-200">
                  {t("app.name")}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10 text-center opacity-10 hover:opacity-80 transition-opacity">
          <small>
            <span>Version: {version}, developed by</span>
            <a className="mx-2" href="https://www.ezmid.com/">
              EZMID
            </a>
            <span>with</span>
            <FontAwesomeIcon
              className="ml-2"
              color="red"
              icon={faHeart}
              size="1x"
            />
          </small>
        </div>
      </div>
    </main>
  );
}
